import { render, staticRenderFns } from "./LegacyUnifiedSearch.vue?vue&type=template&id=d7d405f2&scoped=true"
import script from "./LegacyUnifiedSearch.vue?vue&type=script&lang=js"
export * from "./LegacyUnifiedSearch.vue?vue&type=script&lang=js"
import style0 from "./LegacyUnifiedSearch.vue?vue&type=style&index=0&id=d7d405f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7d405f2",
  null
  
)

export default component.exports